import { ScaleElement } from '@scale/base-element';

class ScaleContactForm extends ScaleElement {
  setup() {
    this.on('submit', (event) => {
      const submit = event.target.querySelector('[type="submit"]');
      if (submit.getAttribute('aria-busy') === 'true') {
        event.preventDefault();
        return;
      }
      submit.setAttribute('aria-busy', 'true');
    });

    window.addEventListener('pageshow', (event) => {
      if (event.persisted) this.querySelector('[type="submit"][aria-busy]')?.removeAttribute('aria-busy');
    }, { signal: this.signal });
  }
}

if (!customElements.get('scale-contact-form')) {
  customElements.define('scale-contact-form', ScaleContactForm);
}
